import { timeFormatLocale } from 'd3-time-format'
export default {
  search: 'Search...',
  catUfk: 'Category',
  catVienna: 'Category',
  catCompensa: 'Category',
  manUfk: 'Manager',
  manVienna: 'Manager',
  manCompensa: 'Manager',
  cur: 'Currency',
  selCatUfk: 'Select Category',
  selCatVienna: 'Select Category',
  selCatCompensa: 'Select Category',
  selCur: 'Select Currency',
  selRisk: 'Select Risk',
  nameUfk: 'Name',
  nameVienna: 'UFK',
  nameCompensa: 'Name',
  codeUfk: 'Code',
  codeVienna: 'Code',
  codeCompensa: 'Code',
  valUfk: 'Valuation',
  valVienna: 'Valuation',
  valCompensa: 'Valuation',
  change: 'Change',
  changeVienna: 'Change',
  changeCompensa: 'Change',
  lastValuationDateUfk: 'Valuation Date',
  lastValuationDateVienna: 'Valuation Date',
  lastValuationDateCompensa: 'Valuation Date',
  dUfk: '1D',
  dVienna: '1D(%)',
  dCompensa: '1D',
  mUfk: '1M',
  mVienna: '1M(%)',
  mCompensa: '1M',
  qUfk: '3M',
  qVienna: '3M(%)',
  qCompensa: '3M',
  hyUfk: '6M',
  hyVienna: '6M(%)',
  hyCompensa: '6M',
  yUfk: '12M',
  yVienna: '12M(%)',
  yCompensa: '12M',
  y3Ufk: '36M',
  y3Vienna: '36M(%)',
  y3Compensa: '36M',
  y5Ufk: '60M',
  y5Vienna: '60M(%)',
  y5Compensa: '60M',
  ytdUfk: 'YTD',
  ytdVienna: 'YTD',
  ytdCompensa: 'YTD',
  maxUfk: 'MAX',
  maxVienna: 'MAX',
  maxCompensa: 'MAX',
  riskUfk: 'Risk',
  riskVienna: 'Risk',
  riskCompensa: 'Risk',
  ufkRiskLevel0: 'None',
  ufkRiskLevel1: 'Very Low',
  ufkRiskLevel2: 'Low',
  ufkRiskLevel3: 'Moderate',
  ufkRiskLevel4: 'Medium',
  ufkRiskLevel5: 'Relatively High',
  ufkRiskLevel6: 'High',
  ufkRiskLevel7: 'Very High',
  viennaRiskLevel1: 'Minimal',
  viennaRiskLevel2: 'Very Low',
  viennaRiskLevel3: 'Low',
  viennaRiskLevel4: 'Medium',
  viennaRiskLevel5: 'High',
  viennaRiskLevel6: 'Highest',
  downCSV: 'Download CSV File',
  showDet: 'See Details',
  initBoxMsg: 'Select fund to dispaly',
  selectMsg: 'Select fund',
  unselectMsg: 'Unselect fund',
  selectMsgLimit: 'Max number of funds selected',
  filters: 'Filters',
  chart: 'Chart',
  panel: 'Panel',
  legend: 'Legend',
  list: 'Fund List',
  groupUfk: 'By category',
  groupVienna: 'By category',
  groupCompensa: 'By category',
  ungroup: 'Alphabetically',
  valOn: 'Valuation on day',
  display: 'Display',
  unselectAll: 'Unselect all funds',
  raiseSelected: 'Selected funds up',
  slot3: 'Three months backwards',
  slot6: 'Six months backwards',
  slot9: 'Nine months backwards',
  slot12: 'One year backwards',
  slot36: 'Three years backwards',
  slotMax: 'Max time range',
  copyLink: 'Copy link',
  copyLinkPop: 'Copy link to clipboard',
  copiedLinkPop: 'Copied!',
  returnRate: 'Return Rate',
  fundValueToolTipPart1: 'Displayed value is rounded to two decimal places. Full value is: ',
  fundValueToolTipPart2: ' and it is available in CSV file',
}

export const locale = timeFormatLocale({
  'dateTime': '%a %e %b %X %Y',
  'date': '%d/%m/%Y',
  'time': '%H:%M:%S',
  'periods': ['AM', 'PM'],
  'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
})



// WEBPACK FOOTER //
// ./src/localization/en.js